module.exports = __webpack_public_path__ + "img/dfwvga-logo-black-mini.966d8b91.png";